<template>
  <div>
    <v-tabs class="w-100" :height="60" bg-color="primary" slider-color="accent" v-model="activeTab">
      <v-tab :key="0">Scheduled</v-tab>
      <v-tab :key="1">Summary</v-tab>
      <v-tab :key="2">Missing Invoice</v-tab>
      <v-tab :key="3">TaxJar Transactions</v-tab>
    </v-tabs>
    <component :is="tabComponents[activeTab]"></component>
  </div>
</template>
<script>
import Scheduled from '@/components/orders/Scheduled'
import OrderSummary from '@/components/orders/OrderSummary'
import MissingInvoice from '@/components/orders/MissingInvoice'
import TaxJarOrderTransaction from '@/components/orders/TaxJarOrderTransaction.vue'

export default {
  name: 'orders',
  components: { Scheduled, OrderSummary, MissingInvoice, TaxJarOrderTransaction },
  data() {
    return {
      activeTab: 0,
      tabComponents: ['Scheduled', 'OrderSummary', 'MissingInvoice', 'TaxJarOrderTransaction']
    }
  }
}
</script>
<style lang="scss" scoped></style>
